import React, { RefObject, useMemo } from "react"
import { ElasticProduct } from "@usereactify/search"

import { useShopify } from "@hooks/useShopify"
import { useAnalytics } from "@hooks/useAnalytics"
import ProductCard from "@components/Product/ProductCard"
import type { CollectionProps } from "@root/types/global"
import { useStorage } from "@hooks/useCore"

export interface ProductGridItemProps {
  product: ElasticProduct
  collection?: CollectionProps | GatsbyTypes.SanityCollection
  pagePosition: number
  itemRef?: RefObject<HTMLDivElement>
  handleClick?: VoidFunction
  onQuickView?: VoidFunction
}

const ProductGridItem = ({ product, pagePosition, itemRef, handleClick, onQuickView, collection }: ProductGridItemProps) => {
  const { setStorage } = useStorage()
  const { trackProductClick } = useAnalytics()
  const { adminProductNormaliser } = useShopify()

  const item = useMemo(() => adminProductNormaliser(product), [adminProductNormaliser, product])

  const handleTrackingClick = () => {
    const currentPosition = document.documentElement.scrollTop
    const clickedTime = new Date().getTime()

    setStorage(
      "collection_scroll_position",
      JSON.stringify({
        collectionHandle: collection?.shopify?.handle,
        position: currentPosition,
        clickedTime,
      })
    )
    trackProductClick(item, item?.variants?.[0], pagePosition, collection?.shopify?.handle, collection?.title)
    handleClick && handleClick()
  }

  const isStl = useMemo(() => product?.tags?.includes("stl"), [product?.tags])

  return (
    <ProductCard
      item={item}
      itemRef={itemRef}
      handleTrackingClick={handleTrackingClick}
      location={location}
      fullSize
      onQuickView={onQuickView}
      collection={collection}
      wishlistSize={"lg"}
      showPlus={!isStl}
      isStl={isStl}
    />
  )
}

export default React.memo(ProductGridItem)
